<app-select-field [label]="'settings.language' | translate" [filled]="true" [required]="false">
  <img class="flag" [src]="currentFlagUrl()" alt="" />
  <kin-select
    name="language"
    id="language-select"
    [value]="languageService.currentLanguage().code"
    (onSelectedValue)="languageService.changeLanguage($event)"
  >
    @for (lang of languageOptions; track lang.code) {
      <option [value]="lang.code">
        {{ lang.name | upperFirstLetter }}
        @if (lang.navigatorLanguage) {
          {{ 'page.settings.navigator_choice' | translate }}
        }
      </option>
    }
  </kin-select>
</app-select-field>
